import React from "react";
import SubjectCard from "../shared/SubjectCard";

const Lists = ({ total }: { total: number }) => {
	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-2">
			{[...Array(total)]?.map((item, i) => (
				<SubjectCard key={i} />
			))}
		</div>
	);
};

export default Lists;
